// Local compatibility is deliberately read-only. A parent payment identifier
// can describe several bank entries, so an alias is a review candidate, not a
// license to rename an accepted transaction or merge its financial history.
export const PAYSERA_ENTRY_IDENTITY = 'paysera-statement-entry-v1';

export function legacyBankStatementConflict(item, transactions = []) {
  if (item?.status === 'Accepted') return '';
  for (const [index, row] of (item?.extraction?.transactions || []).entries()) {
    if (row?.sourceBank !== 'Paysera') continue;
    const modern = row.identityKind === PAYSERA_ENTRY_IDENTITY;
    const candidates = transactions.filter(existing => modern
      ? row.legacyTransactionId && existing.id === row.legacyTransactionId && existing.id !== row.id
      : existing.identityKind === PAYSERA_ENTRY_IDENTITY && existing.legacyTransactionId === row.id);
    for (const existing of candidates) {
      // Different explicit bank entry numbers prove different movements even
      // when their parent payment ID is the same (for example a transfer/fee).
      if (row.statementNumber && existing.statementNumber && String(row.statementNumber) !== String(existing.statementNumber)) continue;
      if (existing.workspaceId !== item.workspaceId || existing.businessId !== item.businessId) {
        return 'Statement row ' + (index + 1) + ': a legacy identity belongs to another business. No rows were imported.';
      }
      return modern
        ? 'Statement row ' + (index + 1) + ': a previously accepted entry may already represent this movement under a legacy payment identity. Review its original accepted statement before proceeding. No records were rewritten, merged, or imported.'
        : 'Statement row ' + (index + 1) + ': this old draft overlaps an entry stored with a bank statement identity. Re-read the retained source before confirmation. No rows were silently remapped or imported.';
    }
  }
  return '';
}
